import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                close: 'close',
                clear: 'clear'
            }
        }

        document.querySelectorAll('.blog-search-field').forEach(el => {
            el.addEventListener('click', () => {
                this.open();
            });
        });
    }

    open() {
        this.call('stop', 'Scroll');
        this.el.classList.add('-open');
        this.el.querySelector('.search-field').focus();
    }

    close() {
        this.call('start', 'Scroll');
        this.el.classList.remove('-open');
    }

    clear() {
        this.el.querySelector('.search-field').value = '';
    }
}
